import { gql } from 'graphql.macro';

export const CreateSheqManager = gql`
  mutation createSheqManager($request: SHEQManagerCollectionSaveRequestModelInput!) {
    createSHEQManager(request: $request)
  }
`;